.card {
  background: var(--nexus-surface);
  border: 1px solid var(--nexus-border);
  border-radius: var(--nexus-radius-surface);
  overflow: hidden;
}

/* Padding variants */

.pad-sm .header,
.pad-sm .body,
.pad-sm .footer { padding: var(--nexus-space-sm); }

.pad-md .header,
.pad-md .body,
.pad-md .footer { padding: var(--nexus-space-md); }

.pad-lg .header,
.pad-lg .body,
.pad-lg .footer { padding: var(--nexus-space-lg); }

.pad-xl .header,
.pad-xl .body,
.pad-xl .footer { padding: var(--nexus-space-xl); }

/* Interactive (hover effects) */

.interactive {
  transition: border-color var(--nexus-transition-normal),
              box-shadow var(--nexus-transition-normal);
}

.interactive:hover {
  border-color: var(--card-accent, var(--nexus-border-strong));
  box-shadow: 0 0 20px -5px var(--card-accent, transparent);
}

/* Gradient border */

.gradientBorder {
  background:
    linear-gradient(var(--nexus-surface), var(--nexus-surface)) padding-box,
    linear-gradient(135deg, var(--nexus-purple), var(--nexus-pink)) border-box;
  border: 1px solid transparent;
}

.gradientBorder.interactive:hover {
  box-shadow: 0 0 30px -5px var(--card-accent, var(--nexus-purple));
}

.header {
  border-bottom: 1px solid var(--nexus-border);
}

.footer {
  border-top: 1px solid var(--nexus-border);
}
